import React, { createContext, useState, useEffect, useContext } from 'react';
import auth from "../services/authService";
import EntityContext from "../context/entityContext";

export const TradeFinanceContext = createContext();

export const TradeFinanceProvider = ({ children }) => {
  const { constants } = auth.getCurrentUser();
  const productId = constants.PRODUCTS.TRADEFINANCE;

  const { entityDetails } = useContext(EntityContext);
 

  const [breadCrumbs, setBreadcrumbs] = useState({});
  const [reloadWidget, setReloadWidget] = useState(false);
  

  return (
    <TradeFinanceContext.Provider
      value={{ breadCrumbs, setBreadcrumbs, productId, reloadWidget, setReloadWidget, entityDetails }}
    >
      {children}
    </TradeFinanceContext.Provider>
  );
};
